import { CustomOffsetRecord, customOffsetToOption, hardcodedFollowUpOffsets } from '@shared/core/custom-offsets'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { ApiService } from 'src/services/api.service'

export function useFollowUpOffsets(options?: UseQueryOptions<CustomOffsetRecord[]>) {
  const { data: customOffsets = [] } = useQuery(
    ['custom-offsets', 'follow_up'],
    () => ApiService.CustomOffsets.getCustomOffsets('follow_up'),
    {
      staleTime: ms('5 minutes'),
      ...options,
    },
  )
  const allOptions = [
    ...hardcodedFollowUpOffsets,
    ...customOffsets.map((offset) => customOffsetToOption(offset, 'follow_up')),
  ]
  allOptions.sort((a, b) => Number(a.value) - Number(b.value))
  return allOptions
}
